<template>
    <div>

        <b-breadcrumb>
            <b-breadcrumb-item to="/">
                <i class="fa fa-home"></i>
                Home
            </b-breadcrumb-item>
            <b-breadcrumb-item to="/Facilities/Offices">Facilities</b-breadcrumb-item>
            <b-breadcrumb-item to="/Facilities/Offices">Offices</b-breadcrumb-item>
            <b-breadcrumb-item active>{{buildingName}}</b-breadcrumb-item>
        </b-breadcrumb>

        <div class="card">
            <div class="bg-dark card-header text-white">Edit Office</div>
            <div class="card-body">
                <div class="card">
                    <div class="card-header">
                        <ul class="card-header-tabs nav nav-tabs">
                            <li class="nav-item">
                                <a @click="currentTabComponent='TheBuildingDetailsForm'" class="active nav-link"
                                   data-toggle="tab"
                                   href="#">Details</a>
                            </li>
                            <li v-if="isTTIOffice" class="nav-item">
                                <a @click="currentTabComponent='TheBuildingSpaceList'" class="nav-link"
                                   data-toggle="tab"
                                   href="#">Rooms/Suites</a>
                            </li>
                        </ul>
                    </div>
                    <div id="tab-container">
                        <keep-alive>
                            <component :building-id="id" v-bind:is="currentTabComponent"/>
                        </keep-alive>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import TheBuildingDetailsForm from "@/components/buildings/TheBuildingDetailsForm.vue";
    import TheBuildingSpaceList from "@/components/buildings/TheBuildingSpaceList.vue";

    export default {
        components: {
            TheBuildingDetailsForm,
            TheBuildingSpaceList
        },
        data() {
            return {
                id: null,
                currentTabComponent: 'TheBuildingDetailsForm',
            }
        },
        props: {
            buildingName: {
                type: String,
                required: false
            },
            isTTIOffice: {
                type: Boolean,
                required: true
            }
        },
        created() {
            this.id = this.$route.params.id;
        }
    }
</script>
